/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import endpointConfig from "../config/endpoints.config.json";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { IMPORT_USERS } from "../graphql";
import { VApplication } from "../../../application";
import { pretty } from "@vlinder-web/utils-react";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGroupServiceMethods extends IPluginMethodMap {
  createGroup(args: any): any;
}

export class GroupService implements IAgentPlugin {
  readonly methods: IGroupServiceMethods;

  constructor() {
    this.methods = {
      createGroup: this.createGroup.bind(this),
    };
  }

  async createGroup(args: any) {
    console.log(`--args`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    let variable: any = {
      users: this.getUsers(args?.validData),
      role: "fe93dab0-424b-4aa3-9efa-c001b4c04444",
    }
    if (args?.section) {
      variable = {
        ...variable,
        sections: args?.section,
      }
    }
    else {
      variable = {
        ...variable,
        sections: null,
      }
    }
    if (args?.notes) {
      variable = {
        ...variable,
        notes: args?.notes
      }
    }
    if (args?.presentationId) {
      variable = {
        ...variable,
        presentation: args?.presentationId,
        invite: true,
        inviteType: "Closed"
      }
    }
    if (args?.partition) {
      variable = {
        ...variable,
        partition: args?.partition,
      }
    }
    if (args?.sectionOptionType) {
      variable = {
        ...variable,
        sectionOptType: args?.sectionOptionType,
      }
    }
    try {
      if (client) {
        console.log("this.getUsers(args?.validData) data===>", pretty(this.getUsers(args?.validData)));
        const res = await client.mutate({
          mutation: IMPORT_USERS,
          variables: variable,
          fetchPolicy: "no-cache",
        });
        if (res?.data?.importUsers) {
          return {
            ...res?.data?.importUsers,
          };
        }
      }
    } catch (err: any) {
      console.log(err);
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }
      throw err;
    }
    // try {
    //   // const res = await axios.post(endpointConfig?.createGroup, {
    //   //   data: args?.validData,
    //   // });
    //   // console.log("created group =>", res?.data);
    //   // return res?.data;
    //   return true;
    // } catch (err: any) {
    //   console.log("Error in create group", err?.message);
    // }
  }
  private getUsers = (data: any) => {
    let _res: any[] =
      data &&
      Array.isArray(data) &&
      data.length > 0 &&
      data.map((item: any) => {
        return {
          ...item,
          invite: true,
        };
      });
    console.log(`---_res data`, _res);
    return _res;
  };
}
